<template>
  <section class="row">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body py-md-4 pt-4 rounded-4 transition-shadow
            box-shadow-pink-300 box-shadow-hover-pink-300"
        >
          <div class="row">
            <div class="col-2">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-8">
              <div class="h5 text-center mb-3">
                J'ajoute un utilisateur
              </div>
            </div>
            <div
              class="col-12 col-md-10 mx-auto"
              :class="{ 'my-4': companyMembers.length > 0 }"
            >
              <transition-group name="flip-list">
                <v-account-member-display
                  v-for="member in companyMembers"
                  :key="member.id"
                  :member="member"
                  class="mb-3"
                  @error="(value) => error = value"
                />
              </transition-group>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <v-loader
                :next="() => $router.push('/client/account/informations/members/add')"
                title="Ajouter un utilisateur"
                icon="plus-white"
                class="w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import AccountMemberDisplay from '../helpers/AccountMemberDisplay.vue';

export default {
  name: 'AccountMembers',
  components: {
    'v-account-member-display': AccountMemberDisplay,
  },
  computed: {
    companyMembers() {
      return this.$store.getters['client/members'];
    },
  },
};
</script>
